import { MetaDataProps } from "@components/Modules/MetaData/types";
import { configSite } from "@pub/config";
import placeholders from "@pub/placeholders";

/**
 * Helps to update the Meta SEO for infinite scrolling of Articles
 */
export const updateDomMetadata = (metaData: MetaDataProps, path: string) => {
  if (metaData.title) {
    document.title = `${metaData.title} | ${configSite.name}`;
  }

  const canonicalUrl = metaData.canonicalUrl
    ? metaData.canonicalUrl
    : `${configSite.address}${path}`;

  const ogTitle = metaData.ogFields?.title || metaData.title;
  const ogDescription = metaData.ogFields?.description || metaData.description;
  const ogImageSrc =
    metaData.ogFields?.image?.src ||
    metaData.image?.src ||
    placeholders.landscape.src;

  const seoList = [
    { selector: 'meta[name="description"]', value: metaData.description },
    {
      selector: 'link[rel="canonical"]',
      attr: "href",
      value: canonicalUrl,
    },
    // Open Graph fields
    { selector: 'meta[property="og:title"]', value: ogTitle },
    { selector: 'meta[property="og:description"]', value: ogDescription },
    { selector: 'meta[property="og:url"]', value: canonicalUrl },
    { selector: 'meta[property="og:image"]', value: ogImageSrc },
  ];

  seoList.forEach(({ selector, value, attr = "content" }) => {
    if (value === undefined) return;

    const element = document.querySelector(selector);
    if (element) {
      element.setAttribute(attr, value);
    }
  });
};
